export default __webpack_public_path__ + "static/feature-banner-ecofriendly-9c884eeeedb19d18384aab2771020774.jpg";